module.exports = __webpack_public_path__ + "static/usability-testing-cover-c8655856fcdbac30f4d12ec169c62bb2.png";